import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d7eb42b2")

_pushScopeId("data-v-d7eb42b2")
const _hoisted_1 = { class: "px-8 py-5 inline-flex justify-between w-full" }
const _hoisted_2 = {
  key: 0,
  class: "rounded-b-md text-xs px-8 py-3 bg-gray-lp-700",
  style: {"box-shadow":"0px -5px 5px -1px #e0e0e0"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        ref: "modal",
        tabindex: "0",
        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["esc"])),
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["self"])),
        class: ["justify-center items-center flex bg-overlay fixed inset-0 z-50", _ctx.showOverflow ? ' overflow-auto' : 'overflow-hidden']
      }, [
        _createVNode("div", {
          class: ["relative bg-white m-auto flex-col flex rounded-lg", _ctx.customWidth]
        }, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            (_ctx.header)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: `${_ctx.title && 'border-b border-gray-lp-400'}`
                }, [
                  _createVNode("div", _hoisted_1, [
                    _createVNode("div", {
                      class: `font-semibold text-${_ctx.titleSize}px ${_ctx.textColor}`
                    }, _toDisplayString(_ctx.title), 3),
                    _createVNode("img", {
                      id: `${_ctx.$attrs.buttonId}`,
                      src: require(`@/app/ui/assets/svg/${_ctx.closeIcon}.svg`),
                      class: "w-5 cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forceCloseDialog && _ctx.forceCloseDialog(...args))),
                      alt: "close"
                    }, null, 8, ["id", "src"])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ], {}, true),
          _createVNode("div", {
            id: `${_ctx.$attrs.contentId}`,
            style: 
          `min-height: 0; ${_ctx.customHeight ? `height:${_ctx.customHeight};` : ''}`
        ,
            class: 
          `${_ctx.customBody} dialog ${_ctx.showOverflow ? 'overflow-y-auto' : ''} ${
            _ctx.customHeight ? 'scroll-height-modal' : ''
          }`
        
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 14, ["id"]),
          _renderSlot(_ctx.$slots, "main-footer", {}, () => [
            (_ctx.footer)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                ]))
              : _createCommentVNode("", true)
          ], {}, true)
        ], 2)
      ], 34))
    : _createCommentVNode("", true)
})